import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import Property from "./Property";
import SizeProperty from "./SizeProperty";
import PropertyGroup from "./PropertyGroup";

const CategoryPanel = props => {
  return (
    <div className="panel">
      <div className="title">{props.title}</div>
      <div className="content">
        <div className="scrollable">{props.children}</div>
      </div>
    </div>
  );
};

const groups = [
  {
    key: "general",
    contains: ["id"]
  },
  {
    key: "position",
    contains: ["position", "top", "left", "bottom", "right", "zIndex"]
  },
  {
    key: "size",
    contains: ["width", "height"]
  },
  {
    key: "background",
    contains: ["background", "backgroundColor"]
  },
  {
    key: "text",
    contains: ["color", "textAlign", "textDecoration", "textIndent", "textOverflow", "textShadow", "textTransform", "font", "fontFamily", "fontSize", "fontStyle", "fontVariant", "fontWeight"]
  }
];

@observer
class PropertiesPanel extends Component {
  @observable document = null;
  // @observable selection;

  @observable propertiesRefs = [];
  __cache = {};
  __states = {};

  constructor(props) {
    super(props);

    this.state = { selection: null };
  }

  setDocument(doc) {
    this.document = doc;
    this.container = this.document.props.parent;
    this.document.registerPropertiesPanel(this);
  }

  handleChange(prop, val) {
    prop.value = val;
  }

  updateDocument() {
    this.setState({
      selection: null
    })
    this.__cache = {};
    this.__states = {};
    this.propertiesRefs = [];
    console.log('RESET');
  }

  format(key, index) {
    const prop = this.document.getProperty(key);
    const visible = !isNaN(prop.visible) ? prop.visible : true;
    if (!visible) return;
    switch (key.toLowerCase()) {
      case "size":
        return (
          <SizeProperty
            key={index}
            onChange={val => this.handleChange(prop, val)}
            property={prop}
          />
        );

      default:
        return (
          <Property
            key={index}
            onChange={val => this.handleChange(prop, val)}
            property={prop}
          />
        );
    }
  }

  handleElementPropChange(prop, val) {
    // console.log("handleElementPropChange");

    const element = this.state.selection;
    // console.log('wut');
    if (!element) return;
    element.set(prop.key, prop.type, val);
    element.updateTransformControls()
    // console.log(element.get(prop.key));
    // console.log(prop.key, prop.type, val);
  }

  formatForElement(key, index) {
    const element = this.state.selection;
    if (!element) return null;

    const prop = element.get(key);
    try {
      const visible = !isNaN(prop.visible) ? prop.visible : true;
      if (!visible) return;

      // return "LOL\n";
      // return <Property key={Math.random()} onChange={(val) => this.handleElementPropChange(prop, val)} property={prop}/>

      switch (key.toLowerCase()) {
        case "size":
          return (
            <SizeProperty
              key={key + index}
              onChange={val => this.handleElementPropChange(prop, val)}
              property={prop}
            />
          );

        default:
          return (
            <Property
              element={this.state.selection}
              onRef={propComp =>
                this.propertiesRefs.push({ key, ref: propComp })
              }
              key={key + index}
              onChange={val => this.handleElementPropChange(prop, val)}
              property={prop}
            />
          );
      }
    } catch (e) {
      return null;
    }
  }

  getPropertyLine(key) {
    const r = this.propertiesRefs.find(el => el.key === key);
    if (!r) return null;
    return r.ref;
  }

  updatePropertyLine(key, value) {
    const line = this.getPropertyLine(key);
    if (!line) return false;
    line.changePropValue(value);
    this.forceUpdate();
  }

  getPropertiesOfSelection() {
    if (!this.container) return;

    const selection = this.state.selection;
    if (!selection) return null;

    let elProps = null;

    // console.log(selection.get('backgroundcolor'));
    // console.log(selection.get("blockSize"));

    elProps = groups.map((el, i) => {
      // selection.getPropertiesObject().map((prop, index) => {
      //   return this.formatForElement(prop.key, index);
      // });
      // return selection.getPropertiesObject().filter(prop => el.contains.includes(prop.key)).map((prop, index) => {
      //   // console.log("Group: #", el.key, ":", prop);
      //   return prop;
      // })
      let properties = [];
      // el.contains.forEach(key => {
      //   properties.push(selection.get(key));
      // })
      const ci = "properties-" + i + "-" + selection.id;
      if (!this.__cache[ci]) {
        el.contains.forEach(key => {
          let prop = selection.get(key);
          if (prop) properties.push(prop);
        });
        this.__cache[ci] = properties;
      } else {
        properties = this.__cache[ci];
      }

      let si = "pgroup"+i+"-" + selection.id;

      if(!this.__states[si])
        this.__states[si] = [
          {
            collapsed: false
          }
        ]

      return (
        <PropertyGroup
          key={"pgroup" + i}
          group={el.key}
          panel={this}
          properties={properties}
          state={this.__states[si]}
        />
      );
    });

    // console.log('Updated category :x');

    return (
      <CategoryPanel title={"ELEMENT PROPERTIES"}>{elProps}</CategoryPanel>
    );
  }

  updateElementProperties() {
    this.forceUpdate();
  }

  onSelectionChanged(selection) {
    this.setState({ selection: null });

    if (selection.length > 1 || selection.length <= 0)
      this.setState({ selection: null });
    else this.setState({ selection: selection[0] });
    // this.forceUpdate();
  }

  render() {
    let documentProps = null;
    if (this.document) {
      documentProps = this.document.properties.map((prop, index) => {
        return this.format(prop.key, index);
      });
    }

    return (
      <div className="propsPanel">
        <CategoryPanel title="DOCUMENT PROPERTIES">
          {documentProps}
        </CategoryPanel>
        {this.getPropertiesOfSelection()}
      </div>
    );
  }
}

export default PropertiesPanel;



// WEBPACK FOOTER //
// ./src/components/ui/PropertiesPanel.js